// Mapea el estado de salud (derivado/roll-up) a la clase de color del dot + label + color.
const MAP = {
  OPERATIVO: { cls: 'ok', label: 'Operativo', color: '#2e6b3a' },
  OBSERVACION: { cls: 'signal', label: 'En observación', color: '#b8861a' },
  CRITICO: { cls: 'err', label: 'Crítico', color: '#9b2a1e' },
};

export function healthStyle(state) {
  return MAP[state] || { cls: 'warn', label: 'Desconocido', color: '#c5561d' };
}
